import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';
import Loader from 'ui-component/Loader';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 *
 * Token refresh is handled transparently by axios interceptors in utils/api.ts
 * - When a 401 occurs, the interceptor automatically refreshes tokens
 * - The original request is retried with the new token
 * - Components don't need to know about the refresh - their request just takes longer
 */
export default function AuthGuard({ children }: GuardProps) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { replace: true });
    }
  }, [isLoggedIn, navigate]);

  // Don't render children if not logged in (prevents unauthorized API calls)
  if (!isLoggedIn) {
    return <Loader />;
  }

  return <>{children}</>;
}
